import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";
import type { UserProfile } from "@/preferences/types";
import { resetAnalyticsUser } from "@/analytics/posthog";

export type AuthState = {
  token: string | null;
  user: UserProfile | null;
  profileHydrated: boolean;
  hasHydrated: boolean;
  setToken: (token: string | null) => void;
  setUser: (user: UserProfile | null) => void;
  setProfileHydrated: (profileHydrated: boolean) => void;
  setHasHydrated: (hasHydrated: boolean) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        token: null,
        user: null,
        profileHydrated: false,
        hasHydrated: false,
        setToken: (token: string | null) => {
          if (token === null) resetAnalyticsUser();
          set({ token });
        },
        setUser: (user: UserProfile | null) => set({ user }),
        setProfileHydrated: (profileHydrated: boolean) => set({ profileHydrated }),
        setHasHydrated: (hasHydrated: boolean) => set({ hasHydrated }),
        signOut: () => {
          resetAnalyticsUser();
          set({ token: null, user: null, profileHydrated: false });
        },
      }),
      {
        name: "hey-jerry-auth",
        partialize: ({ user, profileHydrated }) => ({
          user,
          profileHydrated,
        }),
        merge: (persistedState, currentState) => {
          const persisted = persistedState as Partial<AuthState>;
          return {
            ...currentState,
            user: persisted.user ?? null,
            profileHydrated: persisted.profileHydrated ?? false,
            token: null,
            hasHydrated: false,
          };
        },
      },
    ),
    { name: "useAuthStore" },
  ),
);
